import { SurveyResults } from "@/features/survey-results/survey-results-types";
import SurveyNavbar from "@/features/surveys/SurveyNavbar";
import { Survey } from "@/features/surveys/survey-types";
import { storageService } from "@/services/StorageService";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";

export default function SurveyPage() {
  const location = useLocation();
  const { surveyId } = useParams();
  const [survey, setSurvey] = useState<Survey | undefined>(undefined);
  const [results, setResults] = useState<SurveyResults | undefined>(undefined);

  const updateSurvey = (survey: Survey) => {
    console.info("Updating survey", survey);
    setSurvey(survey);
  };

  const updateResults = (results: SurveyResults) => {
    console.info("Updating results", results);
    setResults(results);
  };

  useEffect(() => {
    if (surveyId === undefined) {
      return;
    }
    storageService.getSurveyById(surveyId).then((survey) => {
      console.info("Set Survey", survey);
      setSurvey(survey);
    });
    storageService.getResultsBySurveyId(surveyId).then((results) => {
      console.info("Set Results", results);
      setResults(results);
    });
  }, [surveyId]);

  return (
    <>
      {survey && (
        <div className="flex flex-col sm:flex-row">
          {!location.pathname.endsWith("edit") && (
            <div className="flex-none">
              <SurveyNavbar survey={survey} />
            </div>
          )}
          <div className="flex-1 h-full overflow-auto">
            {/* <h2 className="text-2xl font-bold mb-4">{survey.metadata.title}</h2> */}
            <Outlet
              context={{ survey, results, updateSurvey, updateResults }}
            />
          </div>
        </div>
      )}
    </>
  );
}
